export enum SolicitacaoRetornoTypes {
  'LOAD_SOLICITACAO_REQUEST' = '@solicitacaoRetorno/LOAD_SOLICITACAO_REQUEST',
  'LOAD_SOLICITACAO_SUCCESS' = '@solicitacaoRetorno/LOAD_SOLICITACAO_SUCCESS',
  'LOAD_SOLICITACAO_FAILURE' = '@solicitacaoRetorno/LOAD_SOLICITACAO_FAILURE',

  'RADIO_SELECT' = '@solicitacaoRetorno/RADIO_SELECT',
}

export interface ISolicitacaoRetorno {

}

export interface IRadio {
  radio: number;
}

export interface SolicitacaoRetornoState {
  readonly data?: ISolicitacaoRetorno[];
  readonly loading: boolean;
  readonly error: boolean;
  readonly radioSelecionado?: IRadio;
}